// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3JKHi","head":"ProcedureTableInfo_head__3oQMU"};